<template>
<section class="root display-mobile">

  <slot name="title">
    <com-h1 :title="pastPre + '热门精选'"></com-h1>
  </slot>

  <div class="tracks">
    <dl v-for="(track, index) in tracks" :key="index" @click="toggle(index)">
      <a class="decription">
        <dt class="change">
          <h4><a>{{track.title}}</a></h4>
          <i :class="show[index]?'active':''"></i>
        </dt>
      </a>
      <a class="decription" :style="{'height': show[index]?'auto':'0'}">
        <div class="inner" :class="track.id===2||track.id===3?'speaker':'lectures'">
          <!-- 热门专题部分 -->
          <div class="down-content" v-if="track.id===0">
            <div v-for="(item, idx) in track.data" :key="idx" class="lecture">
              <router-link :to="'/track/'+item.id">{{'• ' + item.topic}}</router-link>
            </div>
          </div>
          <!-- 热门议题部分 -->
          <div class="down-content" v-if="track.id===1">
            <div v-for="(item, idx) in track.data" :key="idx" class="lecture">
              <router-link :to="'/presentation/'+item.id">{{'• ' + item.title}}</router-link>
            </div>
          </div>
          <!-- 出品人 -->
          <div class="down-content" v-if="track.id===2">
            <div class="container">
               <com-speakers :speakers="track.data"></com-speakers>
            </div>
          </div>
          <!-- 明星讲师 -->
          <div class="down-content container" v-if="track.id===3">
            <div class="container">
               <com-speakers :speakers="track.data"></com-speakers>
            </div>
          </div>
          <!-- <a class="more">专题详情 >></a> -->
        </div>
      </a>
    </dl>
  </div>
  <!-- <div class="box-button"><router-link :to="'/track'"><c-button>查看所有专题及演讲</c-button></router-link></div> -->
</section>
</template>

<script>
import ComH1 from 'gkConUI/com-h1'
// import CButton from '@/components/com-button'
import comSpeakers from 'gkConUI/com-speakers'

export default {
  components: {
    ComH1,
    // CButton,
    comSpeakers
  },
  props: [
    'tracks'
  ],
  data () {
    let show = {}
    for (let id in this.tracks) {
      show[id] = false
    }
    return {
      curId: -1,
      show: show
    }
  },
  computed: {
    pastPre () {
      return this.$store.state.isPastHot === 1 ? '往届' : ''
    }
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
    toggle (id) {
      this.curId = this.curId === id ? -1 : id
      this.show[id] = !this.show[id]
    }
  }
}
</script>

<style lang="sass" scoped>

.root
  padding: 40px 0
.tracks
  margin: 30px 0
dl:first-child
  border-top: 1px solid #ccc
dt
  padding: 12px 4vw
  display: flex
  justify-content: space-between
  align-items: center
  background-color: #fff
  cursor: pointer
  border-bottom: 1px solid #ccc
  a
    color: var(--primary-color)
    font-size: 16px
  i
    float: right
    width: 15px
    height: 8px
    display: block
    background: url('./assets/down.jpg') no-repeat center
    background-size: contain
    // transform: rotate(90deg)
  i.active
    transform: rotate(180deg)
    // background: url('./assets/up.jpg') no-repeat center
.decription
  display: block
  transition: all $speed ease-in-out
  overflow: hidden
  // background-color: #f8f8f8
  .inner
    padding: 18px 4vw
    border-bottom: 1px solid #ccc
    > .more
      font-size: 12px
    &.speaker
      padding-bottom: 30px
    &.lectures
      padding: 0
  .down-content
    font-size: 14px
    line-height: 1.5
    color: #333
    .lecture
      border-bottom: 1px solid #d7d7d7
      padding: 8px 20px
      &:last-child
        border: none
    .container
      margin: 1.5rem auto

</style>
